import { avatarColor, initials } from '../lib/avatar.ts';

/**
 * A small circular avatar showing a name's initials on a deterministic colour.
 * Decorative only — marked aria-hidden because the adjacent text already names
 * the entity for assistive technology. Sized in px so the font scales with it.
 */
export function Avatar({ name, size = 36 }: { name: string; size?: number }) {
  return (
    <span
      aria-hidden="true"
      className={`inline-flex shrink-0 items-center justify-center rounded-full font-semibold leading-none ${avatarColor(name)}`}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.4) }}
    >
      {initials(name)}
    </span>
  );
}
